module.exports = __webpack_public_path__ + "02-magazzino-samuel-zeller-unspalsh.jpg?ac29be7c2582fea4fa820d557b382a65";


//////////////////
// WEBPACK FOOTER
// ./src/img/gioco2/02-magazzino-samuel-zeller-unspalsh.jpg
// module id = 383
// module chunks = 0